/*
    Creation Time: 2021 - Sep - 26
    Created by:  (hamidrezakk)
    Maintainers:
       1.  HamidrezaKK (hamidrezakks@gmail.com)
    Auditor: HamidrezaKK
    Copyright Qlub_ 2022
*/

export function getRandomString(): string {
    return Math.random().toFixed(10).split('.')[1];
}

export function getRandomId(): number {
    return parseInt(getRandomString(), 10);
}
